import { createReducer } from 'Helpers/redux'
import {
  GET_SPOTIFY_TRACKS,
  SET_TRACKS_TO_INITIAL_STATE,
} from '../actions/trackActions'

const initialState = {
  tracks: null,
}

const handlers = {
  [GET_SPOTIFY_TRACKS.SUCCESS]: (prevState, { payload }) => ({
    tracks:
      payload.tracks && payload.tracks.items ? payload.tracks.items : [payload],
  }),
  [SET_TRACKS_TO_INITIAL_STATE]: (prevState, { payload }) => ({
    tracks: payload,
  }),
}

export default createReducer(initialState, handlers)
